import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { csvFileName, getRowOfRT } from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchMailMaster } from "./API";

class MailList extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
        size: 80,
      },
      {
        accessorKey: "vac_event",
        header: "Mail Template Event",
      },
      {
        accessorKey: "vac_subject",
        header: "Mail Template Subject",
      },
      {
        accessorKey: "vac_body",
        header: "Mail Template Body",
        Cell: ({ cell }) => (
          <div
            dangerouslySetInnerHTML={{
              __html: cell.getValue(),
            }}
          />
        ),
      },
    ],

    rows: [],
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "Mail List");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
  }

  //#endregion Component

  //#region Handle

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_event"]);
    if (row && row.bint_srno > 0) {
      let bint_srno = row.bint_srno;
      this.props.navigateTo("MailMaster", { bint_srno });
    } else {
      this.props.toastErrorMsg("Select a record for edit.");
    }
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_subject"]);
    this.DeleteData(row.bint_srno, row.vac_subject);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListMailMaster",
    };
    fetchMailMaster(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.MailMasterList || [],
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
  };

  handleNewMailEntry = () => {
    this.props.navigate("/MailMaster");
  };

  DeleteData = (bint_srno, vac_subject) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_subject} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteMail(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteMail = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteMailMaster",
      bint_srno: bint_srno,
    };
    fetchMailMaster(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (res.data.MailMasterList && res.data.MailMasterList.length > 0) {
            rows = res.data.MailMasterList;
            rowsCount = rows.length;
          }
          this.setState({
            rows,
            rowsCount,
            ARD: null,
          });
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Mail Entry. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        {/* <Grid container direction="row" justifyContent="flex-end">
           <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="new-button"
                  label="New Mail Entry"
                  iconName="new"
                  onClick={this.handleNewMailEntry}
                />
              </Grid>
            </Grid> 
          {/* </Grid> 
        </Grid> */}

        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("Mail List")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              tableButtonAction={[
                {
                  label: "New Mail Entry",
                  onClick: this.handleNewMailEntry,
                  addPluseIcon: true,
                },
              ]}
              showColumnFilters={false}
              actionColSize={80}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <MailList {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
